import React from "react";
import _ from "lodash";
import classnames from "classnames";

import {
  ProfileTabContent,
  ProfileTabDropdown,
} from "../../pages/profiles/components/profileTab/ProfileTab";

import "./WizardProfileTabContent.scss";

interface WizardProfileTabProps {
  title: string;
  menu?: any;
  type?: string;
}

export const WizardProfileTabContent = ({
  menu,
  title,
  type,
}: WizardProfileTabProps) => {
  const hasMenu = !_.isEmpty(menu);
  return (
    <div
      className={classnames("wizard-profile-tab-content", {
        "wizard-profile-tab-content--has-menu": hasMenu,
      })}
    >
      <ProfileTabContent type={type} title={title} />

      {hasMenu && (
        <div className="wizard-profile-tab__menu">
          <ProfileTabDropdown menu={menu} profileName={title} />
        </div>
      )}
    </div>
  );
};
